import Swiper from 'swiper';
import { Manipulation, Autoplay } from 'swiper/modules';

const MIN_SLIDES_TO_SHIFT_START = 3;
const INITIAL_SLIDE_IF_MANY = 1;

const casesSlider = () => {
	const sliderWrapper = document.querySelector('.cases-new__wrapper');
	const filterButtons = document.querySelectorAll('.cases-filter__btn');
	const loaderEl = document.querySelector('.cases-new__loader');
	let allSlidesData = [];
	let currentCategory = 'all';
	let swiper = null;

	function showLoader() {
		if (loaderEl) loaderEl.style.display = 'block';
	}
	function hideLoader() {
		if (loaderEl) loaderEl.style.display = 'none';
	}

	function createSlideHtml(item) {
		return `
      <div class="cases-new__slide swiper-slide" data-category="${item.data}">
        <div class="case-card">
          <div class="case-card__wrapper">
            <div class="case-card__image">
              <img src="${item.img}" alt="" />
            </div>
            <div class="case-card__info">
              <h3 class="case-card__title">${item.title}</h3>
              <p class="case-card__desc">${item.desc}</p>
            </div>
          </div>
        </div>
      </div>`;
	}

	// Общий обработчик подгрузки по reachEnd
	function handleReachEnd() {
		const allCurrent = currentCategory === 'all'
			? allSlidesData
			: allSlidesData.filter(item => item.data === currentCategory);

		const loadedCount = sliderWrapper.querySelectorAll('.swiper-slide').length;
		if (loadedCount >= allCurrent.length) return;

		const next = allCurrent[loadedCount];
		if (next !== undefined) {
			showLoader();
			swiper.appendSlide(createSlideHtml(next));
			hideLoader();
		}
	}

	function highlightFilterButtons() {
		filterButtons.forEach(btn => {
			const isActive = btn.dataset.category === currentCategory;
			btn.classList.toggle('cases-filter__btn_active', isActive);
			btn.toggleAttribute('aria-current', isActive);
		});
	}

	function getInitialSlides() {
		return (currentCategory === 'all'
			? allSlidesData
			: allSlidesData.filter(item => item.data === currentCategory)
		).slice(0, 5);
	}

	function initSwiper(slidesHtml) {
		sliderWrapper.innerHTML = slidesHtml.join('');

		const initialSlideIndex = slidesHtml.length > MIN_SLIDES_TO_SHIFT_START ? INITIAL_SLIDE_IF_MANY : 0;

		swiper = new Swiper('.js-cases-slider', {
			modules: [Manipulation, Autoplay],
			slidesPerView: 'auto',
			centeredSlides: slidesHtml.length > 2,
			spaceBetween: 30,
			initialSlide: initialSlideIndex,
			loop: false,
			watchOverflow: true,
			autoplay: { // Добавляем параметры автопрокрутки
				delay: 3000, // Задержка между слайдами в миллисекундах (3 секунды)
				disableOnInteraction: false, // Продолжать автопрокрутку после взаимодействия пользователя
				waitForTransition: true
			}
		});

		swiper.on('reachEnd', handleReachEnd);
	}

	showLoader();
	// fetch('./libs/cases.json')
	fetch('cases.htm')
		.then(response => response.json())
		.then(data => {
			allSlidesData = data;
			hideLoader();

			// Отключаем фильтры без данных
			filterButtons.forEach(btn => {
				const cat = btn.dataset.category;
				const exists = allSlidesData.some(item => cat === 'all' || item.data === cat);
				btn.disabled = !exists;
				btn.classList.toggle('cases-filter__btn_disabled', !exists);
			});

			// Первоначальная инициализация
			const initialSlides = getInitialSlides().map(createSlideHtml);
			initSwiper(initialSlides);
			highlightFilterButtons();

			// Обработка кликов по фильтрам
			filterButtons.forEach(btn => {
				btn.addEventListener('click', e => {
					e.preventDefault();
					if (btn.disabled || btn.classList.contains('cases-filter__btn_disabled')) return;

					const newCategory = btn.dataset.category;
					if (newCategory === currentCategory) return;
					currentCategory = newCategory;

					const newSlides = getInitialSlides().map(createSlideHtml);

					showLoader();
					swiper.off('reachEnd', handleReachEnd);
					swiper.removeAllSlides();
					swiper.appendSlide(newSlides);
					swiper.slideTo(0);
					swiper.on('reachEnd', handleReachEnd);
					hideLoader();

					highlightFilterButtons();
				});
			});
		})
		.catch(error => {
			console.error('Ошибка загрузки JSON с кейсами:', error);
			hideLoader();
		});
};

export default casesSlider;
